import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Auth provider setup moved into App.js (see <AuthProvider> inside <Router>)
// — it needs react-router's useNavigate(), which requires being rendered
// inside the Router, and the Router itself lives inside App.js rather than
// wrapping it from here. This mirrors the same native/web redirect handling
// Auth0Provider previously did, just backed by Cognito now.

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Registered here rather than left unregistered (Create React App's default)
// because the daily check-in reminder feature needs it to receive Web Push
// messages — see public/service-worker.js. Safe to call even in browsers
// without Push API support; the registration itself just does nothing
// useful there.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((err) => {
      console.error("Service worker registration failed:", err);
    });
  });
}